import { queryOptions } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

export type Assignment = {
  id: string;
  hostAccountId: string;
  status: string;
  planId: string;
  planName: string;
  includedTokens: number;
  overageRate: string;
};

export function assignmentsQueryOptions(page: number) {
  return queryOptions({
    queryKey: ['assignments', page],
    queryFn: async () => {
      const res = await apiFetch(
        `/api/console/customers/assignments?page=${page}&limit=20`,
      );
      if (!res.ok) throw new Error('Failed to load assignments');
      return res.json() as Promise<{
        assignments: Assignment[];
        total: number;
        page: number;
        totalPages: number;
      }>;
    },
  });
}
